import { getCookie, setCookie } from '@resources/js/helpers/cookies'
import { PROMOTION_TYPES } from '@resources/js/components/promotion/config'
import { setImageToOpen } from '@resources/js/components/galleries'
import {
	isMotivated,
	generateMotivatedPartnerLink,
	setNextMotivatedStep,
} from './motivated'
import { generateBcomParamsFromSessionStorage } from '@resources/js/helpers/generateBcomParamsFromSessionStorage'
const initLinks = ({ partnerUrl, type, beforeActionCallback }) => {
	const partnerOpenElements = document.querySelectorAll('.js-clk-open')

	// partnerUrl will be dynamically generated later after click on link
	// this resseting might be deleted in case we need to use parnterUrl from parameters
	partnerUrl = null

	partnerOpenElements.forEach(partnerOpenElement => {

        const checkPreventClick = () => partnerOpenElement.hasAttribute('data-open-once') && +getCookie('clkndr') === 1
        if (checkPreventClick()) return

		partnerOpenElement.addEventListener('click', () => {
            if (checkPreventClick()) return

			// Generated parameters
			const partnerRedirectParams = {
				type: partnerOpenElement.getAttribute('data-type'),
			}
			if (partnerOpenElement.getAttribute('data-bhotel-id')) {
				const bHotelId = partnerOpenElement.getAttribute('data-bhotel-id')
				partnerRedirectParams.bid = bHotelId
				// For highlighted hotel [86bxkw48q]
				partnerRedirectParams.destId = bHotelId
				partnerRedirectParams.destType = 'hotel'
			}

            if (partnerOpenElement.getAttribute('data-hash')) {
                const hash = partnerOpenElement.getAttribute('data-hash')
                partnerRedirectParams.hash = hash
            }

			if (partnerRedirectParams.type === 'image')
				setImageToOpen(partnerOpenElement)

			const sessionParams = generateBcomParamsFromSessionStorage(
				partnerRedirectParams.type
			)
			const linkParams = { ...sessionParams, ...partnerRedirectParams }

			partnerUrl = isMotivated(partnerRedirectParams.type)
				? generateMotivatedPartnerLink(linkParams)
				: PROMOTION_TYPES[type].generateLink(linkParams)

			setCookie('clkndr', 1)

			if (isMotivated(partnerRedirectParams.type)) setNextMotivatedStep()

			if (beforeActionCallback) {
				beforeActionCallback({
					type: partnerRedirectParams.type,
					bid: partnerRedirectParams.bid || null,
					partnerUrl,
				})
			}

			// кастомний URL (закодований в Base64) замість поточної сторінки
			const customSelfUrl = partnerOpenElement.getAttribute(
				'data-custom-self-url'
			)

			if (partnerOpenElement.hasAttribute('data-open-passive')) {
				const openUrl = new URL(
					customSelfUrl ? atob(customSelfUrl) : location.href,
					location.origin
				)

				if (partnerOpenElement.hasAttribute('data-open-hash')) {
					location.hash = partnerOpenElement.getAttribute('data-open-hash') || ''
					openUrl.hash = location.hash
				}

				window.open(openUrl.toString(), '_blank')
				location.href = partnerUrl
			} else {
				window.open(partnerUrl, '_blank')

				// якщо передано кастомний URL - поточна вкладка переходить на нього
				if (customSelfUrl) location.href = atob(customSelfUrl)
			}
		})
	})
}

export default initLinks
